angular.module('gym.contacts').controller('ContactWaiverCtrl', ["$scope", "$rootScope", "$filter", "waiver", function($scope, $rootScope, $filter, waiver) {
  $scope.waiver = waiver.plain();
  $scope.walletDetails = waiver.signed_waiver_wallet_detail_attributes;
  $scope.currency = $rootScope.gym.currency_symbol;
  $scope.contact = waiver.signed_waiver_contacts_attributes[0];
  $scope.tz = $rootScope.gym.tz;
  $scope.gymAddress = function() {
    var w;
    w = $scope.waiver;
    return _.compact([w.waiver_header_address_suburb, w.waiver_header_address_state, w.waiver_header_address_postcode, w.waiver_header_address_country]).join(', ');
  };
  $scope.replaceMergeTags = function() {
    var contact, country, waiverDateValue, waiverForm;
    contact = waiver.signed_waiver_contacts_attributes[0];
    country = waiver.waiver_header_address_country;
    waiverDateValue = $scope.waiver.signed_at ? moment($scope.waiver.signed_at).format('MMMM Do YYYY') : moment().tz($scope.tz).format('MMMM Do YYYY');
    waiverForm = $scope.waiver.signed_waiver_form_attributes;
    waiverForm.gym_tacs_content = $filter('replaceWaiverMergeTags')(waiverForm.gym_tacs_content, contact, country);
    waiverForm.electronic_consent_content = $filter('replaceWaiverMergeTags')(waiverForm.electronic_consent_content, contact, country, waiverDateValue);
    return waiverForm.waiver_release_content = $filter('replaceWaiverMergeTags')(waiverForm.waiver_release_content, contact, country);
  };
  $scope.replaceMergeTags();
  return $scope.membershipTerm = function() {
    var membership, number, unit;
    membership = waiver.first_membership_attributes;
    if (membership.term_number) {
      number = membership.term_number;
      unit = $filter('pluralize')(membership.term_unit, number);
      return `for ${number} ${unit}`;
    } else {
      return 'until further notice';
    }
  };
}]);
